import { gql } from '@apollo/client';

export const UPDATE_ROOM = gql`
  mutation UpdateRoom($record: UpdateRoomInput!) {
    schedule {
      updateRoom(record: $record) {
        ok
        error {
          message
          code
        }
        resultId
        result {
          id
          name
          organization {
            id
            name
          }
          reservationModes {
            reservationMode {
              id
              name
            }
            parallelSlotsNumber
          }
        }
      }
    }
  }
`;
